import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

import adminsTab from './admins-tab'
import altReservationView from './alt-reservation-view'
import directMessages from './direct-messages'
import firestoreChannel from './firestore-channel'
import shopList from './shop-list'
import cashPayout from './cash-payout'
import clockIn from './clock-in'
import currentShop from './shop'
import currentReservation from './reservation'
import entities from './entities'
import payment from './payment'
import flash from './flash'
import transactionsHistory from './transactions-history'
import reconciliations from './reconciliations'
import openGames from './open-games'
import openGameModal from './open-game-modal'
import calendar from './calendar'
import modalCalendar from './modal-calendar'
import gameModal from './game-modal'
import facilityOpenGameModal from './facility-open-game-modal'
import activities from './activities'
import players from './players'
import clients from './clients'
import regions from './regions'
import notifications from './notifications'
import sideBar from './side-bar'
import pushNotifications from './push-notifications'
import autoMessages from './auto-messages'
import gameAutoMessages from './game-auto-messages'
import clientPortal from './client-portal'
import messageTemplates from './message-templates'
import leagues from './leagues'
import league from './league'
import regionsFilter from './regions-filter'
import landingPage from './landing-page'
import resetPasswordForm from './reset-password-form'
import banners from './banners'
import partners from './partners'
import partner from './partner'

const admin = combineReducers({
  adminsTab,
  altReservationView,
  directMessages,
  firestoreChannel,
  clockIn,
  entities,
  flash,
  shopList,
  cashPayout,
  currentShop,
  currentReservation,
  payment,
  transactionsHistory,
  reconciliations,
  openGames,
  openGameModal,
  calendar,
  modalCalendar,
  gameModal,
  facilityOpenGameModal,
  activities,
  clients,
  regions,
  players,
  notifications,
  sideBar,
  pushNotifications,
  autoMessages,
  gameAutoMessages,
  clientPortal,
  messageTemplates,
  leagues,
  league,
  regionsFilter,
  landingPage,
  resetPasswordForm,
  banners,
  partners,
  partner,
  form
})

export default admin
